const m_style = {

  ntv_brd_a : { border : 'solid #ee2625 1px' },
  blk_brd_a : { border : 'solid #EAEAEA 1px' },

  ntv_bt_brd_a : { borderBottom : 'solid #ee2625 1px' },
  blk_bt_brd_a : { borderBottom : 'solid #EAEAEA 1px' },

  ntv_tp_dash_b : { borderTop : 'dashed #ee2625 3px' },
  blk_tp_dash_brd_a : { borderTop : 'dashed #EAEAEA 1px' },

  ntv_lf_brd_b : { borderLeft : 'solid #ee2625 5px' },

  ntv_rg_brd_c : { borderRight : 'solid #ee2625 10px' },

  ntv_bg_color_b : { backgroundColor: '#ee2625' },

  gry_bg_color_a : { backgroundColor: '#d9d9d9' },

  gren_bg_color_a : { backgroundColor: '#00cb00' },
  
  gren_dark_bg_color_a : { backgroundColor: '#03a353' }
}

export default m_style;
